/* Silk Body Oil PDP behaviour. Idempotent: safe to load once per section. */
(function () {
  'use strict';

  if (window.__sboInit) return;
  window.__sboInit = true;

  var money = function (cents, format) {
    var n = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, n);
  };

  /* shop.money_format is the shop's own currency, not the market the visitor is
     browsing in, so any price the script rewrites would drop back to the wrong
     currency and separators. Instead the section renders 1111.11 through
     Liquid's money filter and we read the shape off that: symbol, placement,
     grouping and decimal separators all come straight from Shopify, so what the
     script writes is byte-identical to what Liquid rendered. */
  function moneyFormatter(probe, format) {
    var m = probe && probe.match(/\d[\d.,\u00a0\u202f ']*\d/);
    if (!m) return function (cents) { return money(cents, format); };

    var num = m[0];
    var prefix = probe.slice(0, m.index);
    var suffix = probe.slice(m.index + num.length);
    /* A non-digit two places from the end is the decimal separator. Money
       formats that drop the cents have a digit there instead. */
    var decimal = /\D/.test(num.slice(-3, -2)) ? num.slice(-3, -2) : '';
    var whole = decimal ? num.slice(0, -3) : num;
    var grouping = (whole.match(/\D/) || [''])[0];

    return function (cents) {
      var c = Math.round(cents);
      var sign = c < 0 ? '-' : '';
      c = Math.abs(c);
      var units = decimal ? String(Math.floor(c / 100)) : String(Math.round(c / 100));
      if (grouping) units = units.replace(/\B(?=(\d{3})+(?!\d))/g, grouping);
      var frac = decimal ? decimal + ('0' + (c % 100)).slice(-2) : '';
      return sign + prefix + units + frac + suffix;
    };
  }

  /* --- Scroll to the buy box ---------------------------------------------
     Every secondary "Add to cart" on the page is a link to #buy. Rather
     than letting the browser jump, ease up to the buy box and stop clear
     of the sticky header. Bound once on the document so it keeps working
     for sections the theme editor renders later. */
  function buyBox() {
    return document.querySelector('[data-sbo-buybox]') || document.getElementById('buy');
  }

  function headerOffset() {
    var header = document.querySelector('.sbo-header');
    if (!header) return 12;
    /* Only a pinned header covers the target. */
    var fixed = getComputedStyle(header).position;
    if (fixed !== 'sticky' && fixed !== 'fixed') return 12;
    return header.getBoundingClientRect().height + 12;
  }

  function animateScroll(to, done) {
    var from = window.pageYOffset;
    var delta = to - from;
    if (Math.abs(delta) < 2) { done(); return; }

    /* Long jumps get a little more time, but never a slow crawl. */
    var duration = Math.min(800, Math.max(320, Math.abs(delta) * 0.4));
    var start = null;
    var cancelled = false;

    var stop = function () { cancelled = true; };
    window.addEventListener('wheel', stop, { passive: true, once: true });
    window.addEventListener('touchstart', stop, { passive: true, once: true });

    var step = function (now) {
      if (cancelled) return;
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      /* easeInOutQuad */
      var eased = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      window.scrollTo(0, from + delta * eased);
      if (t < 1) requestAnimationFrame(step);
      else {
        window.removeEventListener('wheel', stop);
        window.removeEventListener('touchstart', stop);
        done();
      }
    };
    requestAnimationFrame(step);
  }

  function initScrollToBuy() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest ? e.target.closest('a[href*="#buy"]') : null;
      if (!link) return;

      /* Ignore links pointing at another page that happens to end in #buy. */
      var href = link.getAttribute('href') || '';
      if (href.charAt(0) !== '#' && link.pathname !== window.location.pathname) return;

      var target = buyBox();
      if (!target) return;

      e.preventDefault();

      var top = window.pageYOffset + target.getBoundingClientRect().top - headerOffset();
      if (top < 0) top = 0;

      var atc = target.querySelector('.sbo-atc__btn');
      var land = function () {
        /* Send the keyboard along with the eye. */
        if (!atc) return;
        atc.setAttribute('tabindex', '-1');
        atc.focus({ preventScroll: true });
      };

      /* No animation for anyone who asked not to have one, and none in a
         hidden tab, where rAF is throttled and the scroll would stall. */
      if (document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, top);
        land();
        return;
      }

      /* Animated by hand rather than with behavior:'smooth' so the timing
         is consistent and a flick of the wheel can interrupt it. */
      animateScroll(top, land);
    });
  }

  /* --- Live viewer count -------------------------------------------------
     Drifts within the merchant's range on a timer. A random walk rather
     than a fresh random pick each time: jumping 21 -> 84 -> 23 reads as
     fake, while a wander of a few at a time reads like real traffic. */
  function initLiveCount(root) {
    var els = root.querySelectorAll('[data-sbo-live-count]');

    Array.prototype.forEach.call(els, function (el) {
      /* The editor re-renders sections in place; drop the old timer. */
      if (el.__sboTimer) clearInterval(el.__sboTimer);

      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var every = parseInt(el.getAttribute('data-every'), 10);

      if (isNaN(min)) min = 20;
      if (isNaN(max)) max = 87;
      if (isNaN(every) || every < 1) every = 17;
      if (max < min) { var swap = min; min = max; max = swap; }

      var span = max - min;
      var current = min + Math.floor(Math.random() * (span + 1));

      var show = function (n) {
        current = n;
        el.classList.add('is-changing');
        setTimeout(function () {
          el.textContent = String(n);
          el.classList.remove('is-changing');
        }, 180);
      };

      var next = function () {
        if (span < 1) return min;
        /* Step by up to a fifth of the range, at least 1, never nowhere. */
        var reach = Math.max(1, Math.round(span / 5));
        var move = 0;
        while (move === 0) move = Math.floor(Math.random() * (reach * 2 + 1)) - reach;

        var n = current + move;
        /* Bounce off the ends instead of piling up against them. */
        if (n < min) n = min + (min - n);
        if (n > max) n = max - (n - max);
        if (n < min || n > max) n = min + Math.floor(Math.random() * (span + 1));
        return n;
      };

      el.textContent = String(current);
      el.__sboTimer = setInterval(function () { show(next()); }, every * 1000);
    });
  }

  /* --- Header drawer ----------------------------------------------------- */
  function initHeader(root) {
    var btn = root.querySelector('.sbo-header__burger');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = root.hasAttribute('data-open');
      if (open) root.removeAttribute('data-open');
      else root.setAttribute('data-open', '');
      btn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* --- Gallery ----------------------------------------------------------- */
  function initGallery(root) {
    var slides = root.querySelector('.sbo-gallery__slides');
    if (!slides) return;

    var count = slides.children.length;
    if (!count) return;

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.sbo-gallery__thumb'));
    var vids = Array.prototype.slice.call(slides.querySelectorAll('[data-sbo-video]'));
    var index = 0;

    /* Autoplay is driven from here rather than the autoplay attribute, so only
       the slide the visitor is actually on downloads and plays. */
    function syncVideos() {
      vids.forEach(function (v) {
        var active = slides.children[index] && slides.children[index].contains(v);
        if (!active) {
          v.pause();
          return;
        }
        if (v.getAttribute('data-autoplay') !== 'true') return;
        var played = v.play();
        if (played && played.catch) played.catch(function () {});
      });
    }

    vids.forEach(function (v) {
      /* With autoplay off the visitor presses play themselves, which is a user
         gesture, so the sound setting can be honoured straight away. */
      if (v.getAttribute('data-autoplay') !== 'true') {
        v.addEventListener('play', function () {
          v.muted = v.getAttribute('data-sound') !== 'true';
        });
      }
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-sbo-sound]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentNode.querySelector('[data-sbo-video]');
        if (!v) return;
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', String(!v.muted));
      });
    });

    function go(i) {
      index = (i + count) % count;
      slides.style.transform = 'translateX(' + -index * 100 + '%)';
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', String(n === index));
      });
      syncVideos();
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { go(n); });
    });

    var prev = root.querySelector('.sbo-gallery__arrow--prev');
    var next = root.querySelector('.sbo-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    /* Touch swipe */
    var x0 = null;
    slides.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    slides.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    go(0);
  }

  /* --- Accordion --------------------------------------------------------- */
  function initAccordion(root) {
    var list = root.querySelector('.sbo-acc');
    if (!list) return;
    var single = list.hasAttribute('data-single');
    var btns = Array.prototype.slice.call(list.querySelectorAll('.sbo-acc__btn'));

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (single) {
          btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        }
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* --- Bundle tiers + purchase plans ------------------------------------- */
  function initOffer(root) {
    var priceNow = Array.prototype.slice.call(root.querySelectorAll('[data-sbo-price-now]'));
    var priceWas = root.querySelector('[data-sbo-price-was]');
    var priceSave = root.querySelector('[data-sbo-price-save]');
    var instalAmt = Array.prototype.slice.call(root.querySelectorAll('[data-sbo-instal]'));
    var format = root.getAttribute('data-money-format') || '${{amount}}';
    var cash = moneyFormatter(root.getAttribute('data-money-probe'), format);
    /* The current price optionally carries the currency code. */
    var cashNow = root.getAttribute('data-price-code') === 'true'
      ? moneyFormatter(root.getAttribute('data-money-probe-code'), format)
      : cash;

    var tiers = Array.prototype.slice.call(root.querySelectorAll('.sbo-tier'));
    var plans = Array.prototype.slice.call(root.querySelectorAll('.sbo-plan'));

    function activeTier() {
      return tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0];
    }
    function activePlan() {
      return plans.filter(function (p) { return p.classList.contains('is-active'); })[0] || plans[0];
    }

    function refresh() {
      var tier = activeTier();
      if (!tier || !priceNow.length) return;

      var total = parseInt(tier.getAttribute('data-total'), 10);
      var compare = parseInt(tier.getAttribute('data-compare'), 10);
      if (isNaN(total)) return;

      var plan = activePlan();
      var off = plan ? parseInt(plan.getAttribute('data-discount') || '0', 10) : 0;
      if (off > 0) total = Math.round(total * (100 - off) / 100);

      priceNow.forEach(function (el) {
        el.textContent = el.classList.contains('sbo-price__now') ? cashNow(total) : cash(total);
      });

      if (priceWas) {
        var show = !isNaN(compare) && compare > total;
        priceWas.textContent = show ? cash(compare) : '';
        priceWas.style.display = show ? '' : 'none';
      }
      if (priceSave) {
        var save = !isNaN(compare) ? compare - total : 0;
        priceSave.textContent = save > 0 ? 'Save ' + cash(save) : '';
        priceSave.style.display = save > 0 ? '' : 'none';
      }
      /* Each element carries its own instalment count. */
      instalAmt.forEach(function (el) {
        var n = parseInt(el.getAttribute('data-sbo-instal'), 10) || 4;
        el.textContent = cash(Math.round(total / n));
      });
    }

    /* Only the chosen tier posts its line items. Disabled fields are left
       out of the submission, which is what keeps the other tiers' products
       from landing in the cart too. */
    /* The refill reassurance lines belong to the subscription option only. */
    var subsOnly = Array.prototype.slice.call(root.querySelectorAll('[data-sbo-subs]'));
    function syncSubs() {
      if (!subsOnly.length) return;
      var plan = activePlan();
      var isSub = plan ? plan.getAttribute('data-subscription') === 'true' : true;
      /* With no purchase options at all there is nothing to gate on. */
      if (!plans.length) isSub = true;
      subsOnly.forEach(function (el) { el.hidden = !isSub; });
    }

    function syncBundle() {
      tiers.forEach(function (t) {
        var on = t.classList.contains('is-active');
        var fields = t.querySelectorAll('[data-sbo-bundle-input]');
        Array.prototype.forEach.call(fields, function (f) { f.disabled = !on; });
      });
    }

    function select(group, el) {
      group.forEach(function (g) { g.classList.toggle('is-active', g === el); });
      var input = el.querySelector('input[type="radio"]');
      if (input) input.checked = true;
      syncBundle();
      syncSubs();
      refresh();
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(tiers, t); });
    });
    plans.forEach(function (p) {
      p.addEventListener('click', function (e) {
        /* Let the frequency dropdown work without re-selecting. */
        if (e.target.closest('.sbo-freq')) return;
        select(plans, p);
      });
    });

    syncBundle();
    syncSubs();
    refresh();
  }

  /* --- Quantity stepper -------------------------------------------------- */
  function initQty(root) {
    var box = root.querySelector('.sbo-qty');
    if (!box) return;
    var input = box.querySelector('input');
    if (!input) return;

    box.addEventListener('click', function (e) {
      var step = e.target.closest('[data-step]');
      if (!step) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-step'), 10);
      input.value = Math.max(min, next);
    });
  }


  /* --- Countdown timer ---------------------------------------------------- */
  function initCountdown(root) {
    var clocks = root.querySelectorAll('[data-countdown]');
    Array.prototype.forEach.call(clocks, function (clock) {
      var hours = parseFloat(clock.getAttribute('data-countdown')) || 8;
      var key = 'sbo-countdown-' + (clock.getAttribute('data-key') || 'default');
      var end;
      try { end = parseInt(window.localStorage.getItem(key), 10); } catch (err) { end = NaN; }
      if (!end || isNaN(end) || end < Date.now()) {
        end = Date.now() + hours * 3600 * 1000;
        try { window.localStorage.setItem(key, String(end)); } catch (err) {}
      }
      var h = clock.querySelector('[data-unit="h"]');
      var m = clock.querySelector('[data-unit="m"]');
      var sEl = clock.querySelector('[data-unit="s"]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = Math.max(0, end - Date.now());
        var total = Math.floor(left / 1000);
        if (h) h.textContent = pad(Math.floor(total / 3600));
        if (m) m.textContent = pad(Math.floor((total % 3600) / 60));
        if (sEl) sEl.textContent = pad(total % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* --- Small click popovers ----------------------------------------------
     A [data-pop] button toggles the [data-pop-panel] next to it. Only one
     popover stays open at a time; a click outside or Escape closes it. */
  function initPops(root) {
    var btns = root.querySelectorAll('[data-pop]');
    if (!btns.length) return;

    function closeAll(except) {
      var all = document.querySelectorAll('[data-pop]');
      Array.prototype.forEach.call(all, function (b) {
        if (b === except) return;
        var p = b.parentNode.querySelector('[data-pop-panel]');
        b.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
    }

    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.__sboPop) return;
      btn.__sboPop = true;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var panel = btn.parentNode.querySelector('[data-pop-panel]');
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeAll(btn);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });

    if (document.__sboPopBound) return;
    document.__sboPopBound = true;

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.sbo-pop')) return;
      closeAll(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* --- Generic tab groups ------------------------------------------------- */
  function initTabs(root) {
    var groups = root.querySelectorAll('[data-tabs]');
    Array.prototype.forEach.call(groups, function (group) {
      group.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-tab]');
        if (!tab || !group.contains(tab)) return;
        var name = tab.getAttribute('data-tab');
        var tabs = group.querySelectorAll('[data-tab]');
        Array.prototype.forEach.call(tabs, function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        var panels = group.querySelectorAll('[data-panel]');
        Array.prototype.forEach.call(panels, function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === name);
        });
      });
    });
  }

  /* --- Stat count-up -----------------------------------------------------
     Runs the first time a stat is on screen. The target keeps whatever
     prefix and suffix the merchant typed ("93%", "-40%", "3.5x"), so only
     the number itself is animated. */
  function initCountUp(root) {
    var els = root.querySelectorAll('[data-sbo-count]');
    if (!els.length) return;

    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(els, function (el) {
      if (el.__sboCounted) return;

      var raw = el.getAttribute('data-sbo-count') || el.textContent;
      var parts = raw.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!parts) return;

      var head = parts[1];
      var tail = parts[3];
      var target = parseFloat(parts[2].replace(',', '.'));
      /* "93.5" animates to one decimal, "93" stays whole. */
      var dot = parts[2].indexOf('.') >= 0 || parts[2].indexOf(',') >= 0;
      var places = dot ? parts[2].replace(/^\d+[.,]/, '').length : 0;

      var write = function (n) { el.textContent = head + n.toFixed(places) + tail; };

      var run = function () {
        if (el.__sboCounted) return;
        el.__sboCounted = true;

        var rail = el.closest('[data-count-ms]');
        var span = rail ? parseInt(rail.getAttribute('data-count-ms'), 10) : 1400;
        if (isNaN(span) || span < 1) span = 1400;

        var start = null;
        var step = function (now) {
          if (start === null) start = now;
          var t = Math.min(1, (now - start) / span);
          /* easeOutCubic — quick off the mark, gentle landing. */
          write(target * (1 - Math.pow(1 - t, 3)));
          if (t < 1) requestAnimationFrame(step);
          else write(target);
        };
        requestAnimationFrame(step);
      };

      if (still || typeof IntersectionObserver === 'undefined') {
        write(target);
        el.__sboCounted = true;
        return;
      }

      /* Hold at zero until it is seen, otherwise the reader scrolls past a
         number that already finished counting. */
      write(0);

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          run();
        });
      }, { threshold: 0.6 });

      io.observe(el);
    });
  }

  /* --- Horizontal rails: keep the progress bar in sync -------------------- */
  function initRails(root) {
    var rails = root.querySelectorAll('[data-rail]');
    Array.prototype.forEach.call(rails, function (rail) {
      var bar = document.querySelector('#' + rail.getAttribute('data-rail-progress'));
      if (!bar) return;
      var fill = bar.firstElementChild;
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth;
        var pct = rail.clientWidth / rail.scrollWidth;
        var pos = max > 0 ? rail.scrollLeft / max : 0;
        fill.style.width = Math.min(100, pct * 100) + '%';
        fill.style.marginLeft = (pos * (100 - Math.min(100, pct * 100))) + '%';
      }
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      // A rail inside a hidden tab panel measures 0 wide, so re-sync once it
      // gains a size (tab switch, breakpoint change).
      if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
      sync();
    });
  }

  /* --- "Show more" text clamps -------------------------------------------- */
  function initClamps(root) {
    var buttons = root.querySelectorAll('[data-clamp-toggle]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var target = btn.parentNode.querySelector('[data-clamp]');
      if (!target) return;
      btn.addEventListener('click', function () {
        var open = target.classList.toggle('is-clamped') === false;
        btn.textContent = open ? btn.getAttribute('data-less') || 'Show less'
                               : btn.getAttribute('data-more') || 'Show more';
      });
    });
  }

  /* --- Inline video posters ------------------------------------------------ */
  function initVideoCards(root) {
    var plays = root.querySelectorAll('.sbo-vcard__play');
    Array.prototype.forEach.call(plays, function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.parentNode;
        var video = media.querySelector('video');
        if (!video) return;
        btn.style.display = 'none';
        var poster = media.querySelector('img');
        if (poster) poster.style.display = 'none';
        video.style.display = 'block';
        video.play();
      });
    });
  }

  /* --- Full-list popups ---------------------------------------------------
     Each popup is authored inside its accordion panel but lifted out to <body>
     on load, so no clipped, sticky or transformed ancestor in the buy box can
     trap the fixed overlay. */
  function closeModals() {
    var open = document.querySelectorAll('[data-sbo-modal]:not([hidden])');
    Array.prototype.forEach.call(open, function (m) { m.hidden = true; });
    document.body.classList.remove('sbo-modal-open');
  }

  function initModals(root) {
    var modals = root.querySelectorAll('[data-sbo-modal]');
    Array.prototype.forEach.call(modals, function (m) {
      if (m.parentNode === document.body) return;
      // The theme editor re-renders the section, so drop the previous copy first.
      var stale = document.querySelector('body > [data-sbo-modal][id="' + m.id + '"]');
      if (stale) stale.parentNode.removeChild(stale);
      document.body.appendChild(m);
    });

    if (document.__sboModalBound) return;
    document.__sboModalBound = true;

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var opener = e.target.closest('[data-sbo-modal-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-sbo-modal-open'));
        if (!target) return;
        closeModals();
        target.hidden = false;
        document.body.classList.add('sbo-modal-open');
        return;
      }
      if (e.target.closest('[data-sbo-modal-close]')) closeModals();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModals();
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('.sbo');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.hasAttribute('data-sbo-ready')) return;
      root.setAttribute('data-sbo-ready', '');
      initHeader(root);
      initGallery(root);
      initAccordion(root);
      initOffer(root);
      initQty(root);
      initCountdown(root);
      initTabs(root);
      initPops(root);
      initModals(root);
      initRails(root);
      initCountUp(root);
      initClamps(root);
      initVideoCards(root);
      initLiveCount(root);
    });
  }

  initScrollToBuy();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* Theme editor re-renders a section in place. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
